import { defineStore } from "pinia";
import { CR_API_KEY } from "../models/constants-general";
import { ConfigApi } from "../cr-userprofile-api-client/src";
import { transport_type_to_vehicle_id_mapping } from "../models/transport";
import { reversedRouteModesOEPV } from "../ui-mappings";

const baseUrl = () => `${window.CLEVERROUTE_HOST || '.'}/api/v1`

export const useConfigStore = defineStore({
  id: "config",
  state: () => ({
    /**
   * @param pageLoading whether the page is loading or not
   * @param currentOrsApiIndex current API-key used for OpenRoute requests
   * @param orsApiKeys all available API-keys for OpenRoute
   * @param searchRunning status of the search request 
   */
    currentOrsApiIndex: 0,
    orsApiKeys: [],
    pageLoading: true,
    searchRunning: false,
    metricToSortRoutesBy: "time",
    metricToJourneyThereTimeOrientation: "arrival",
    transportGroupsBuilt: [],
    allowPastDate: false,
    metricToJourneyThereTimeOrientation: "arrival",
    showFooterLogos: true,
    showProviderBookingButton: true,
    showProviderDescriptionText: true,
    showFahrgemeinschaftButton: true,
    journeyThereDateTime: undefined, // format '2025-06-05T08:00:02Z'
    journeyBackDateTime: undefined, // format '2025-06-05T08:00:02Z'
    showMap: true,
    instanceId: undefined, 
    showMapToolbar: true,
    showHeaderImage: true,
    transports: [],
    vehicles: [], // vehicle types like car, bicycles
    vehiclesSpec: [] // vehicle spec of vehicles inluding öpv types like tram, subway. Individual vehicles include spec like consumption, fuel-type etc.

  }),
  getters: {
    /**
     * return ORS api key of current index
     * @param {*} state 
     * @returns 
     */
    getOrsApiKey: (state) => {
      return state.orsApiKeys[state.currentOrsApiIndex];
    },
  },
  actions: {
    /**
     * rotate ORS index of the API-keys-array
     */
    switchOrsApiKey() {
      // rotate keys only if keys are stored
      if (this.orsApiKeys.length > 0) {
        this.currentOrsApiIndex = (this.currentOrsApiIndex + 1) % this.orsApiKeys.length;
      }
    },
    /**
     * setting the status of the loading status of the route search
     * @param {*} status status to set to like true or false
     */
    setPageLoading(status) {
      this.pageLoading = status;
    },
    changeUsageOfVehicleLocally(val, vehicleId, providerName) {
      const vehicleIndex = this.vehicles.findIndex(v => v.vehicleId === vehicleId);
      this.vehicles.splice(vehicleIndex, 1, { vehicleId: vehicleId, isUsed: val, ui: {providerName: providerName} });
    },
    changeUsageOfVehicleSpecLocally(val, vehicleId) {
      const vehicleIndex = this.vehiclesSpec.findIndex(v => v.ownVehicleId === vehicleId);
      this.vehiclesSpec.splice(vehicleIndex, 1, { ownVehicleId: vehicleId, isUsed: val });
    },
    saveUsageOfVehicleRemotely(userId) {
      console.log("saveUsageOfVehicleRemotely",userId, this.vehicles)
      new ConfigApi().modifyUsageOfTransportsOfUser(userId, { body: this.vehicles }, (error, data, response) => {
        console.log("saveUsageOfVehicleRemotely-data=", data, "-error=", error, "-response=", response);
        if (!(data instanceof Array)) {
          return;
        }
      });
    },
    saveUsageOfVehicleSpecRemotely(userId) {
      function isOepvVehicle(vehicleId) {
        if (Object.keys(reversedRouteModesOEPV).includes(vehicleId)) {
          return true;
        } else {
          return false;
        }
      }

      // remove isUsed attribute from ownVehicles because it is adapted in the other function
      const oepVehicles = this.vehiclesSpec.filter(v => isOepvVehicle(v.ownVehicleId))
      console.log("saveUsageOfVehicleSpecRemotely",userId, this.vehiclesSpec)
      new ConfigApi().modifySpecOfVehiclesOfUser(userId, { body: oepVehicles }, (error, data, response) => {
        console.log("saveUsageOfVehicleSpecRemotely-data=", data, "-error=", error, "-response=", response);
        if (!(data instanceof Array)) {
          return;
        }
      });
    },
    
    fetchTransportsOfUser(userId) {
      console.log(userId)
      new ConfigApi().transportsOfUser(userId, { instanceId: 'default' }, (error, data, response) => {
        if (!(data instanceof Array)) {
          return;
        }
        console.log("fetchTransportsOfUser-transports=", data)
        console.log("userid=", userId)
        console.log("car-transport=", data.filter(t => t.id === 'car'))
        this.transports = data.map(d => ({ ...d }));
        let vehiclesListOfDic = [];
        let vehiclesList = [];
        this.transports.forEach((t) => {
          if (t.ui.providerName === null &&
            !vehiclesList.includes(
              transport_type_to_vehicle_id_mapping[t.transportType]
            )
          ) {
    
            vehiclesList.push(transport_type_to_vehicle_id_mapping[t.transportType]);
            vehiclesListOfDic.push({
              vehicleId: transport_type_to_vehicle_id_mapping[t.transportType],
              isUsed: t.isUsed,
              ui: {providerName: t.ui.providerName || 'default'}
            });
          }
        });
        this.vehicles = vehiclesListOfDic;
        // const settingsTotalObj = SettingsTotal.constructFromObject(data);
        // this.routingsSettings = settingsTotalObj.routingsSettings;
        // this.userMetricsSettings = settingsTotalObj.userMetricsSettings;
        // this.userProfileSettings = settingsTotalObj.userProfileSettings;
        // this.vehiclesSpec = settingsTotalObj.vehiclesSpec;
        // this.tickets = settingsTotalObj.tickets;
      })
    },
    fetchVehiclesSpecOfUser(userId) {
      console.log(userId)
      new ConfigApi().vehiclesOfUser(userId, { instanceId: 'default' }, (error, data, response) => {
        if (!(data instanceof Array)) {
          return;
        }
        console.log("fetchVehiclesSpecOfUser-transports=", data)
    
        this.vehiclesSpec = data.map(d => ({ ...d }));
       
      });
    },
    fetchTransportGroups() {
      const api =
        `${baseUrl()}/config/transportGroupsBuilt`;

      fetch(api, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'x-api-key': CR_API_KEY

        }
      })
        .then((response) => response.json())
        .then(({ data }) => {
          if (data.hasOwnProperty("transportgroupsBuilt")) {
            this.transportGroupsBuilt = data.transportgroupsBuilt;
          }

        })
        .catch((error) => console.log(error));
    },
    /**
 * setting the status of search request
 * @param {*} status status to set to like true or false
 */
    setSearchRunning(status) {
      this.searchRunning = status;
    },
    /**
     * set keys only if it is defined and is an array
     * @param {*} keys 
     */
    setOrsApiKeys(keys) {
      if (keys && keys instanceof Array) {
        this.orsApiKeys = keys;
      }
    },
    setFrontendConfig(frontendConfig) {
      if (frontendConfig.instanceId !== undefined) {
        this.instanceId = frontendConfig.instanceId;
      }
      // only if sortByValue is passed set it, otherwise use the default value
      if (frontendConfig.metricToSortRoutesBy !== undefined) {
        this.metricToSortRoutesBy = frontendConfig.metricToSortRoutesBy;
      }
      if (frontendConfig.showFooterLogos !== undefined) {
        this.showFooterLogos = frontendConfig.showFooterLogos;
      }
      if (frontendConfig.showMap !== undefined) {
        this.showMap = frontendConfig.showMap;
      }
      if (frontendConfig.showMapToolbar !== undefined) {
        this.showMapToolbar = frontendConfig.showMapToolbar;
      }
      if (frontendConfig.showHeaderImage !== undefined) {
        this.showHeaderImage = frontendConfig.showHeaderImage;
      }
      if (frontendConfig.showProviderBookingButton !== undefined) {
        this.showProviderBookingButton = frontendConfig.showProviderBookingButton;
      }
      if (frontendConfig.showProviderDescriptionText !== undefined) {
        this.showProviderDescriptionText = frontendConfig.showProviderDescriptionText;
      }
      if (frontendConfig.showFahrgemeinschaftButton !== undefined) {
        this.showFahrgemeinschaftButton = frontendConfig.showFahrgemeinschaftButton;
      }
      if (frontendConfig.journeyThereDateTime !== undefined) {
        this.journeyThereDateTime = frontendConfig.journeyThereDateTime;
      }
      if (frontendConfig.journeyBackDateTime !== undefined) {
        this.journeyThereDatejourneyBackDateTimeTime = frontendConfig.journeyBackDateTime;
      }
    },
    setMetricToSortRoutesBy(val) {
      // only if sortByValue is passed set it, otherwise use the default value
      if (val) {
        this.metricToSortRoutesBy = val;
      }
    },
    setAllowPastDate(val) {
      if (val) {
        this.allowPastDate = val;
      }
    },
    setMetricToJourneyThereTimeOrientation(val) {
      if (val) {
        this.metricToJourneyThereTimeOrientation = val;
      }
    }
  },
});
